<script>
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import FormInput from 'v3/components/Form/Input.vue';
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, email } from '@vuelidate/validators';
export default {
  components: {
    NextButton,
    FormInput,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    displayName: {
      type: String,
      default: '',
    },
    emailEnabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['updateUser'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      userName: this.name || '',
      userDisplayName: this.displayName || '',
      userEmail: this.email || '',
    };
  },
  validations: {
    userName: {
      required,
      minLength: minLength(1),
    },
    userDisplayName: {},
    userEmail: {
      required,
      email,
    },
  },
  watch: {
    name: {
      handler(value) {
        this.userName = value || '';
      },
      immediate: true,
    },
    displayName: {
      handler(value) {
        this.userDisplayName = value || '';
      },
      immediate: true,
    },
    email: {
      handler(value) {
        this.userEmail = value || '';
      },
      immediate: true,
    },
  },
  methods: {
    async updateUser() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        useAlert(this.$t('PROFILE_SETTINGS.FORM.ERROR'));
        return;
      }
      this.$emit('updateUser', {
        name: this.userName,
        displayName: this.userDisplayName,
        email: this.userEmail,
      });
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="updateUser('profile')">
    <FormInput
      v-model="userName"
      name="user_name"
      :label="$t('PROFILE_SETTINGS.FORM.NAME.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.NAME.PLACEHOLDER')"
      :has-error="v$.userName.$error"
      :error-message="$t('PROFILE_SETTINGS.FORM.NAME.ERROR')"
      @input="v$.userName.$touch"
      @blur="v$.userName.$touch"
    />
    <FormInput
      v-model="userDisplayName"
      name="user_display_name"
      :label="$t('PROFILE_SETTINGS.FORM.DISPLAY_NAME.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.DISPLAY_NAME.PLACEHOLDER')"
      :has-error="v$.userDisplayName.$error"
      :error-message="$t('PROFILE_SETTINGS.FORM.DISPLAY_NAME.ERROR')"
      @input="v$.userDisplayName.$touch"
      @blur="v$.userDisplayName.$touch"
    />
    <FormInput
      v-if="emailEnabled"
      v-model="userEmail"
      name="user_email"
      :label="$t('PROFILE_SETTINGS.FORM.EMAIL.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.EMAIL.PLACEHOLDER')"
      :has-error="v$.userEmail.$error"
      :error-message="$t('PROFILE_SETTINGS.FORM.EMAIL.ERROR')"
      @input="v$.userEmail.$touch"
      @blur="v$.userEmail.$touch"
    />
    <div>
      <NextButton type="submit" :label="$t('PROFILE_SETTINGS.BTN_TEXT')" />
    </div>
  </form>
</template>
